export default __webpack_public_path__ + "static/media/eye-active-icon.6f9df573.svg";